module.exports = __webpack_public_path__ + "static/media/Inter-Bold.91e5aee8.ttf";